import {AccreditationEventIssuanceCriteriaFields} from "../partials/AccreditationEventIssuanceCriteriaFields";
import {labelValueArrayToObject} from "../../util";
import {useEffect, useState} from "react";

const ContentAccreditationAttributes = props => {

  const values = props.contentAccreditations;

  const [contentAccreditationData, setContentAccreditationData] = useState(props.contentAccreditationData);
  const {ajax} = window.Tangible

  const fetchAccreditationConfig = (accreditation_id) => {

    ajax('tgbl_cred_get_accreditation_content_config', {accreditation_id})
      .then((res) => {

        setContentAccreditationData(prevData => ({
          ...prevData,
          [accreditation_id]: {
            field_specifications: res.field_specifications,
            point_types: res.point_types
          }
        }));

        tangibleFields.store.setValue('tgbl_cred_content_accreditations', tangibleFields.store.getValue('tgbl_cred_content_accreditations'));

      })
      .catch(error => {
        console.error('TGBL Cred Ajax error', error)
      }).finally(() => {
      })
  }

  const accreditationRepeater = tangibleFields.render({
    type: 'repeater',
    name: 'tgbl_cred_content_accreditations',
    value: values,
    layout: 'block',
    sectionTitle: 'Content',
    useSwitch: 'true',
    onChange: (accreditationAttributes) => {
      for( const attributes of accreditationAttributes ) {
        const accred_id = attributes.accreditation_id;
        if( accred_id && !contentAccreditationData[accred_id] ) {
          fetchAccreditationConfig(accred_id);
        }
      }
    },
    fields: [
      {
        type: 'hidden',
        name: 'agency_id'
      },
      {
        type: 'select',
        name: 'accreditation_id',
        label: 'Accreditation Name',
        choices: window.tgblCredAccreditations,
      }, {
        type: 'combo-box',
        name: 'earning_event',
        label: 'Event',
        choices: props.contentEvents,
      }, {
        type: 'combo-box',
        name: 'eligible_professions',
        label: 'Eligible Professions',
        multiple: true,
        choices: labelValueArrayToObject(window.tgblCredProfessions)
      }, {
        type: 'fieldInstances',
        name: 'agency_fields',
        fieldDefs: getValue => {
          return contentAccreditationData[getValue('accreditation_id')]?.field_specifications ?? []
        },

      }, {
        type: 'issuanceTrainingCodes',
        name: 'training_codes',
        scheduledTypesArgs: window.tgblCredScheduledTypesArgs,
      },

      // Earned Points
      {
        type: 'issuanceEarnedPoints',
        name: 'earned_points',
        pointTypes: getValue => {
          return contentAccreditationData[getValue('accreditation_id')]?.point_types ?? []
        }
      },

    ],
    // AccreditationEventIssuanceCriteriaFields(args),
  })


  return (
    <div className="tgbl_cred_content_accreditations">
      {accreditationRepeater}
    </div>
  );

};

export {ContentAccreditationAttributes}
